import React from 'react';

// Update these strings when you send the final wording.
export const homeText = {
  heroEyebrow: 'Bismillah',
  heroTitle: (
    <>
      Welcome to <span className="gold">Masjid Annoor</span> Wichita
    </>
  ),
  heroSubtitle:
    'A sanctuary of serenity and reflection, Masjid Annoor is more than just a place of worship—it is a home filled with faith, warmth, and tradition. Rooted in the timeless teachings of Islam, we are a community devoted to worship, learning, and service. Whether you are a student, a visitor, or a long-time resident, we welcome you to join us—explore, connect, and share in the spirit of faith and friendship. Come experience the peace, unity, and sense of belonging that define our religion.',
};
